export function getErrorMessage({ nodes, elementName, hideChildrenWithIssues, children }) {

  const elementNamesToShow = new Set();
  nodes.forEach(node => {
    const currentKey = getCurrentPropertyKey(node.path);
    elementNamesToShow.add(elementName || currentKey || 'element');
  });

  if (!elementNamesToShow.size) {
    elementNamesToShow.add(elementName || 'element');
  }

  return !hideChildrenWithIssues || !children
    ? `ERROR: ${[...elementNamesToShow].join(", ")} will be shown differently in PROD`
    : `ERROR: ${[...elementNamesToShow].join(", ")} will be hidden in PROD`;
}

function getCurrentPropertyKey(targetPath) {
  if (targetPath && typeof targetPath === 'string') {
    let propertyKey = targetPath.split('.').pop();

    if (propertyKey && propertyKey.includes("[") && propertyKey.includes("]")) {
      const arraySplit = propertyKey.split("[");
      propertyKey = arraySplit.shift();
      const arrayNumber = Number(arraySplit.shift().split("]").shift());
      propertyKey = `${propertyKey}#${arrayNumber + 1}`;
    }

    return propertyKey;
  }
}
